export type Platform = 'youtube' | 'instagram' | 'tiktok';

export function validateCreatorUrl(url: string): Platform | null {
	const trimmedUrl = url.trim();
	const preparedUrl = trimmedUrl?.includes('?')
		? trimmedUrl.split('?')[0]
		: trimmedUrl;

	const patterns: Record<Platform, RegExp> = {
		youtube:
			/^(https?:\/\/)?(www\.)?(youtube\.com\/(c\/|@|user\/|channel\/)?[a-zA-Z0-9\-_]+|youtu\.be\/[a-zA-Z0-9\-_]+)\/?$/,
		instagram: /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9._]+\/?$/,
		tiktok: /^(https?:\/\/)?(www\.)?tiktok\.com\/@[\w.-]+\/?$/,
	};

	for (const platform in patterns) {
		if (patterns[platform as Platform].test(preparedUrl)) {
			return platform as Platform;
		}
	}

	return null;
}
